import { render } from "./index.vue?vue&type=template&id=09c01acc&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=09c01acc&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-09c01acc"

export default script